(() => {
  const RANGES = [
    { size: 'XS', fit: 'Meget smalt', min: 109, max: 119, filters: ['Smal', 'XS'] },
    { size: 'S', fit: 'Smalt', min: 120, max: 126, filters: ['Smal'] },
    { size: 'M', fit: 'Medium', min: 127, max: 132, filters: ['Medium'] },
    { size: 'L', fit: 'Bredt', min: 133, max: 139, filters: ['Bred'] },
    { size: 'XL', fit: 'Ekstra bredt', min: 140, max: 150, filters: ['XL'] }
  ];

  const SELECTORS = {
    overlay: '#GlassifySizeGuideOverlay',
    drawer: '#GlassifySizeGuideDrawer',
    open: '[data-size-guide-open]',
    close: '[data-size-guide-close]'
  };

  function findRange(width) {
    return RANGES.find((range) => width >= range.min && width <= range.max) || null;
  }

  function buildCollectionUrl(category, size) {
    const base = category === 'solbriller' ? '/collections/solbriller-med-styrke' : '/collections/briller';
    const range = RANGES.find((item) => item.size === size);
    const params = new URLSearchParams();
    if (range) range.filters.forEach((filter) => params.append('filter.p.m.filters.fit', filter));
    const query = params.toString();
    return query ? `${base}?${query}` : base;
  }

  function setRecommendation(container, result, currentSize, category) {
    const recommendation = container.querySelector('[data-recommendation]');
    if (!recommendation) return;
    recommendation.classList.remove('is-success', 'is-error');

    if (!result) {
      recommendation.textContent = 'Indtast en bredde mellem 109 og 150 mm for at se din anbefalede størrelse.';
      recommendation.classList.add('is-error');
      return;
    }

    const matchesCurrentFrame = currentSize && result.size === currentSize;
    const productLabel = category === 'solbriller' ? 'solbriller' : 'briller';
    const buttonText = matchesCurrentFrame ? `Se flere ${productLabel} i denne størrelse` : `Se andre ${productLabel} i din størrelse`;
    const lead = matchesCurrentFrame
      ? `Dit mål passer til størrelse ${result.size}, som matcher dette stel.`
      : `Dit mål passer bedst til størrelse ${result.size}. Dette stel er ${currentSize ? `størrelse ${currentSize}` : 'ikke størrelsesmarkeret'}.`;

    recommendation.classList.add(matchesCurrentFrame ? 'is-success' : 'is-error');
    recommendation.innerHTML = '';

    const text = document.createElement('span');
    text.textContent = `${lead} Typisk bredde: ${result.min}-${result.max} mm.`;

    const link = document.createElement('a');
    link.className = 'recommendation-button';
    link.href = buildCollectionUrl(category, result.size);
    link.textContent = buttonText;

    recommendation.append(text, link);
  }

  function updateRows(container, result) {
    container.querySelectorAll('[data-size-row]').forEach((row) => {
      const marker = row.querySelector('[data-user-marker]');
      const isUserRow = result && row.getAttribute('data-size') === result.size;
      row.classList.toggle('is-match', Boolean(isUserRow));
      if (marker) marker.hidden = !isUserRow;
    });
  }

  function initMeasurementGuide(container) {
    if (!container || container.dataset.sizeGuideInitialized === 'true') return;
    const input = container.querySelector('[data-width-input]');
    const currentFrame = container.querySelector('[data-current-size]');
    if (!input || !currentFrame) return;

    const category = currentFrame.getAttribute('data-product-category') || 'briller';

    const update = () => {
      const value = Number.parseInt(input.value, 10);
      const result = Number.isFinite(value) ? findRange(value) : null;
      updateRows(container, result);
      setRecommendation(container, result, currentFrame.getAttribute('data-current-size') || '', category);
    };

    input.addEventListener('input', update);
    input.addEventListener('change', update);
    document.addEventListener('frame-size-change', () => { if (input.value) update(); });
    container.dataset.sizeGuideInitialized = 'true';
    if (input.value) update();
  }

  function openDrawer(overlay, drawer) {
    overlay.hidden = false;
    requestAnimationFrame(() => overlay.classList.add('is-open'));
    document.documentElement.classList.add('size-guide-drawer-open');
    document.body.classList.add('size-guide-drawer-open');
    drawer?.focus({ preventScroll: true });
  }

  function closeDrawer(overlay) {
    overlay.classList.remove('is-open');
    document.documentElement.classList.remove('size-guide-drawer-open');
    document.body.classList.remove('size-guide-drawer-open');
    window.setTimeout(() => {
      if (!overlay.classList.contains('is-open')) overlay.hidden = true;
    }, 280);
  }

  function initDrawer(root = document) {
    const overlay = root.querySelector?.(SELECTORS.overlay) || document.querySelector(SELECTORS.overlay);
    const drawer = root.querySelector?.(SELECTORS.drawer) || document.querySelector(SELECTORS.drawer);
    if (!overlay || overlay.dataset.drawerInitialized === 'true') return;

    document.querySelectorAll(SELECTORS.open).forEach((button) => {
      button.addEventListener('click', () => openDrawer(overlay, drawer));
    });

    overlay.querySelectorAll(SELECTORS.close).forEach((button) => {
      button.addEventListener('click', () => closeDrawer(overlay));
    });

    overlay.addEventListener('click', (event) => {
      if (event.target === overlay) closeDrawer(overlay);
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && !overlay.hidden) closeDrawer(overlay);
    });

    overlay.dataset.drawerInitialized = 'true';
  }

  function initAll(root = document) {
    initDrawer(root);
    root.querySelectorAll?.('[data-glassify-size-guide]').forEach(initMeasurementGuide);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
